import { ProductUnion } from "./ProductUnion";
import { Customer } from "./Customer";
import { Person } from "./Person";
import { CaseInsurance } from "./CaseInsurance";
import { BackofficeCase } from "./BackofficeCase";
import { MediaObject } from "./MediaObject";
import { LeadStatusBasicCase } from "./LeadStatusBasicCase";
import { BackofficeUserPerson } from "./BackofficeUserPerson";
import { CourtAppointment } from "./CourtAppointment";
import { LitigationUnion } from "./LitigationUnion";
import { DocumentUnion } from "./DocumentUnion";
import { BankData } from "./BankData";
import { PartnerReferenceLike } from "./PartnerReference";
import { CaseOrganization } from "./CaseOrganization";
import { Authority } from "./Authority";

export const litigationProductClassNames = [
  "eventContract",
  "membershipContract",
  "otherContract",
  "providerContract",
  "purchaseContract",
  "serviceContract",
  "subscriptionContract",
  "travelContract",
  "vehicleContract",
  "dataLeakContract",
  "employmentContract",
  "rentalContract",
  "trafficAccident",
  "generalCivilLaw",
  "civilServiceLaw",
  "pendingCase",
] as LitigationUnion["productClassName"][];

export const productClassNames = [
  "familyLawCase",
  "divorce",
  "alimony",
  "death",
  "shortTimeWork",
  "settlement",
  "traffic",
  "powerOfAttorney",
  "patientDecree",
  "pendingCase",
  ...litigationProductClassNames,
] as (ProductUnion["productClassName"] | DocumentUnion["productClassName"])[];

export interface AbstractCase {
  "@id": string;
  id: number;
  leadStatus: number;
  leadStatusList?: number[];
  applicationStatus: number;
  customer: Customer;
  client: Omit<Person, "bankData"> & { bankData: BankData };
  legalExpenseInsurance: boolean | null;
  caseInsurance: CaseInsurance;
  powerOfAttorney: string | null;
  caseCategory: string | null;
  caseCategoryAssessment: string | null;
  caseRejectionCategory: string | null;
  assessmentRejectionText: string | null;
  powerOfAttorneyDocument: MediaObject | null;
  personalTextMessage: string | null;
  caseDescription: string;
  electronicFileFolderId: string | null;
  paymentType: string | null;
  backofficeCase: BackofficeCase;
  leadStatusLog: LeadStatusBasicCase[] | null;
  followUpCase: ProductUnion | null;
  historicProductId: number | null;
  acquisitionPartner: PartnerReferenceLike;
  createdBy: string | null;
  landingPage: string | null;
  eConsultDossierId: string | null;
  lawyerCounselingCall: JSON | null;
  preventAllSystemEmails: boolean | null;
  preventAccounting: boolean | null;
  preventStatusChangeByCustomer: boolean | null;
  created: string | null;
  updated: string | null;
  cancelledByCustomerDate: string | null;
  caseClassificationByInsurance: string | null;
  responsibleLawyer: BackofficeUserPerson | null;
  reference: string;
  backofficeCaseLb: BackofficeCase;
  signatories: Person[];
  additionalClients: Person[];
  petitioner: Person;
  productClassName: (typeof productClassNames)[number];
  productCategory: string;
  stage: number;
  // TODO: Fix Correct Typing, can also be null
  courtAppointments: CourtAppointment[];
  missingDocuments: string[] | null;
  requiredFields: Record<number, string[]> | null;
  plaintiff: Person | CaseOrganization | Authority | null;
  defendant: Person | CaseOrganization | Authority | null;
  [additionalProperty: string]: any;
}

export function isLitigationCase(product: ProductUnion): product is LitigationUnion {
  return (litigationProductClassNames as readonly string[]).includes(product.productClassName as string);
}
